if (!customElements.get('rivo-rewards-cash-back')) {
  class RivoRewardsCashBack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const messageContainer = this.querySelector('.product-detail-rivo-loy-message');
      const rivoPrice = parseFloat(messageContainer.dataset.rivoPrice.replace(/[^0-9.]/g, ''));
      const rivoQuantity = parseInt(messageContainer.dataset.rivoQty);
      const rivoTotalPrice = rivoPrice * rivoQuantity;
      const rivoRewardsMessage = messageContainer.dataset.rivoMessage;
      const rivoBalanceToCashMultiplier = parseFloat(messageContainer.dataset.rivoBalanceToCashMultiplier);
      const rivoCashBackMoney = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(rivoTotalPrice * rivoBalanceToCashMultiplier);
      messageContainer.innerHTML = `<span>${rivoRewardsMessage.replace('[[cash]]', rivoCashBackMoney)}</span>`;
    }

    disconnectedCallback() {}
  }

  customElements.define('rivo-rewards-cash-back', RivoRewardsCashBack);
}
